import React from "react";
import {TheMain} from './Style.js'

const Photo = () => {
    return(
        <TheMain>
        </TheMain>
    )
}
export default Photo;